<script setup>
import { computed, inject, ref, watch } from 'vue'
const { global, pages } = inject('Shared')
const showMore = ref(false)
const showBtn = ref(true)
watch(showMore, value => {
  if (!value) {
    setTimeout(() => {
      showBtn.value = true
    }, 1000)
  } else {
    showBtn.value = false
  }
})

function toggleItem (label) {
  pages.value.detailReport.firstSteps.checklist.items = pages.value.detailReport.firstSteps.checklist.items.map(item => {
    if (item.label === label) {
      item.selected = !item.selected
    } else {
      item.selected = false
    }
    return item
  })
}

const selectedItem = computed(() => {
  const res = pages.value.detailReport.firstSteps.checklist.items.find(e => e.selected)
  if (res) {
    return res
  }
  return pages.value.detailReport.firstSteps.checklist.items[0]
})
</script>

<template lang="pug">
.checkListContainer(v-if="pages.detailReport.firstSteps.checklist")
  .mainText {{ pages.detailReport.firstSteps.checklist.title }}
  .bodyText {{ pages.detailReport.firstSteps.checklist.subtitle }}
  .checkListItemsContainerV1.row
    .col-lg-6.col-md-6.col-sm-12.col-xs-12.checkListItem(v-for="item in pages.detailReport.firstSteps.checklist.items" :key="item.label" @click="toggleItem(item.label)")
      svg.checkListSvg(width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' v-if="!item.selected")
        path(d='M7 11.8636L10.6111 16L17 9' :stroke='global.graphicElementColor' stroke-linecap='round')
        circle(cx='12' cy='12' r='11.5' :stroke='global.graphicElementColor')
      svg.checkListSvg(width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' v-else)
        path(d='M23.5 12C23.5 18.3513 18.3513 23.5 12 23.5C5.64873 23.5 0.5 18.3513 0.5 12C0.5 5.64873 5.64873 0.5 12 0.5C18.3513 0.5 23.5 5.64873 23.5 12Z' :fill='global.graphicElementColor' :stroke='global.graphicElementColor')
        path(d='M7 11.8636L10.6111 16L17 9' stroke='white' stroke-linecap='round')
      .label {{ item.label }}
  .bottomContainer
    .svgContainer
      svg.svg(width='50' height='49' viewBox='0 0 50 49' fill='none' xmlns='http://www.w3.org/2000/svg')
        g(clip-path='url(#clip0_2785_2366)')
          path(d='M49.5913 6.00952L43.6871 0.451605C43.5791 0.319455 43.4435 0.211915 43.2896 0.136377C43.1357 0.0608399 42.9672 0.0190812 42.7955 0.013916H19.1505C18.8184 0.0157519 18.5005 0.147561 18.2664 0.38058C18.0322 0.613598 17.9008 0.928866 17.9008 1.25748V5.06465L9.5675 6.45412C9.25086 6.51189 8.96921 6.68906 8.78194 6.94825C8.59466 7.20744 8.5164 7.52842 8.56357 7.8436L8.98479 10.2821C6.27487 11.1853 3.49474 12.1163 0.812913 13.0611C0.507207 13.1739 0.258232 13.4006 0.119176 13.6927C-0.0198795 13.9848 -0.0379851 14.3191 0.0687421 14.6243L5.41133 29.3111C5.45894 29.4562 5.5535 29.5817 5.68039 29.6684C5.80727 29.755 5.95941 29.7979 6.11338 29.7905C6.19935 29.7902 6.28475 29.7761 6.36615 29.7488C6.45825 29.7195 6.5432 29.6717 6.61575 29.6084C6.6883 29.5451 6.74684 29.4676 6.78771 29.3809C6.82858 29.2941 6.85092 29.1999 6.85327 29.1042C6.85562 29.0085 6.83798 28.9134 6.80142 28.8248L1.52199 14.4159C4.04937 13.5196 6.66802 12.6443 9.24454 11.7897L11.7579 26.3098L14.6574 43.0322C14.7097 43.3156 14.8603 43.572 15.0834 43.7572C15.3064 43.9424 15.5878 44.0447 15.8789 44.0465H16.0825L23.9244 42.7126L30.0533 41.6774L20.8354 44.9566L13.5692 47.541L7.95275 31.9997C7.92317 31.9086 7.8749 31.8245 7.81092 31.7527C7.74694 31.6809 7.66866 31.623 7.58099 31.5825C7.49332 31.5421 7.39813 31.52 7.30143 31.5177C7.20473 31.5153 7.10861 31.5328 7.01905 31.569C6.92634 31.5975 6.84059 31.6448 6.76727 31.7078C6.69395 31.7708 6.63465 31.8481 6.59309 31.935C6.55152 32.0218 6.52858 32.1162 6.52577 32.2123C6.52296 32.3083 6.54034 32.4039 6.57676 32.493L12.3055 48.2497C12.3909 48.4859 12.5482 48.6901 12.7556 48.8344C12.963 48.9787 13.2104 49.0559 13.4639 49.0556C13.6057 49.0572 13.7464 49.0313 13.8781 48.9792L21.369 46.3183L38.3656 40.2741L41.6161 39.7183H48.791C49.1225 39.7183 49.4403 39.588 49.6746 39.3561C49.909 39.1242 50.0407 38.8096 50.0407 38.4817V6.87795C50.0386 6.72094 50.0009 6.5664 49.9304 6.42571C49.86 6.28503 49.7585 6.16177 49.6335 6.06507L49.5913 6.00952ZM47.6467 6.17625H43.8907C43.7152 6.17625 43.308 6.17624 43.1886 6.07898C43.0693 5.98172 43.1325 5.97478 43.1325 5.82888V1.91054L47.6467 6.17625ZM48.5593 38.2176H19.3611V24.0866C19.3611 23.9024 19.2871 23.7257 19.1555 23.5954C19.0238 23.4651 18.8452 23.3919 18.659 23.3919C18.4728 23.3919 18.2943 23.4651 18.1626 23.5954C18.0309 23.7257 17.957 23.9024 17.957 24.0866V38.4261C17.957 38.754 18.0886 39.0686 18.323 39.3005C18.5573 39.5324 18.8752 39.6627 19.2066 39.6627H32.9036L23.6717 41.2328L16.0544 42.525L13.1971 26.0319L10.0449 7.85056L17.9008 6.51667V20.7241C17.8961 20.8182 17.9107 20.9123 17.9439 21.0006C17.977 21.089 18.0279 21.1697 18.0936 21.238C18.1593 21.3062 18.2383 21.3605 18.3259 21.3976C18.4134 21.4346 18.5077 21.4537 18.6029 21.4536C18.6981 21.4537 18.7924 21.4346 18.8799 21.3976C18.9675 21.3605 19.0464 21.3062 19.1121 21.238C19.1778 21.1697 19.2288 21.089 19.2619 21.0006C19.2951 20.9123 19.3097 20.8182 19.3049 20.7241V1.45203H41.6161V5.83584C41.6047 6.06927 41.6418 6.30253 41.7251 6.52121C41.8084 6.73988 41.9362 6.9393 42.1005 7.10718C42.5523 7.48744 43.138 7.67483 43.7292 7.62824H48.5593V38.2176Z' fill='white')
          path(d='M31.56 11H37.14L36.21 24.71H32.49L31.56 11ZM34.35 32.24C33.53 32.24 32.84 31.98 32.28 31.46C31.74 30.92 31.47 30.27 31.47 29.51C31.47 28.75 31.74 28.12 32.28 27.62C32.82 27.1 33.51 26.84 34.35 26.84C35.19 26.84 35.88 27.1 36.42 27.62C36.96 28.12 37.23 28.75 37.23 29.51C37.23 30.27 36.95 30.92 36.39 31.46C35.85 31.98 35.17 32.24 34.35 32.24Z' fill='white')
        defs
          clipPath#clip0_2785_2366
            rect(width='50' height='49' fill='white')
    .containerContent(:class="showMore ? 'showMoreContent' : ''")
      .textsContainer
        .normalText
          span(v-html="selectedItem.notExpandedText")
          span.mehrText.gt-sm(v-if="showBtn" @click="showMore = true") Mehr erfahren.
          .mehrText.lt-md(v-if="showBtn" @click="showMore = true") Mehr erfahren.
      .hiddenContent(v-if="selectedItem")
        .normalText(v-html="selectedItem.expandedText")
        .showLess(@click="showMore = false") Weniger anzeigen.
</template>

<style lang="sass" scoped>
.checkListContainer
  background: rgba(255, 255, 255, 0.7)
  border: 1px solid #D9D9D9
  box-sizing: border-box
  box-shadow: 0px 15px 30px rgba(166, 166, 166, 0.25)
  border-radius: 10px
  @media screen and (min-width: 1024px)
    margin-top: 90px
    padding: 40px
  @media screen and (max-width: 1023px)
    padding: 40px 20px
    margin-top: 60px
  .mainText
    font-weight: 700
    font-size: 16px
    line-height: 130%
    color: #22223C
    margin-bottom: 25px
  .bodyText
    font-weight: 500
    font-size: 16px
    line-height: 130%
    color: #626C85
    margin-bottom: 35px
  .checkListItemsContainerV1
    width: 100%
    margin-bottom: 40px
    .checkListItem
      display: flex
      flex-direction: row
      align-items: center
      padding: 7.5px 0
      cursor: pointer
      .checkListSvg
        min-width: 30px
        margin-right: 15px
        width: 24px
        height: 24px
      .label
        font-weight: 500
        font-size: 16px
        line-height: 130%
        color: #626C85
  .bottomContainer
    background: #2F3849
    border: 1px solid #D9D9D9
    box-sizing: border-box
    backdrop-filter: blur(40px)
    border-radius: 10px
    padding: 30px
    position: relative
    @media screen and (min-width: 1024px)
      padding: 30px
    @media screen and (max-width: 1023px)
      padding: 30px 20px 20px 20px
    .svgContainer
      background: linear-gradient(325.28deg, rgba(0, 123, 255, 0.8) -7.64%, rgba(95, 239, 192, 0.48) 102.78%)
      backdrop-filter: blur(20px)
      border-radius: 4px
      width: 34px
      height: 34px
      position: absolute
      display: flex
      justify-content: center
      align-items: center
      @media screen and (min-width: 1024px)
        top: -17px
        left: 25px
      @media screen and (max-width: 1023px)
        top: -17px
        left: 20px
      .svg
        width: 23px
        height: 23px
    .showMoreContent
      max-height: 1000px !important
    .containerContent
      overflow-y: hidden
      transition: max-height 1s ease
      @media screen and (min-width: 1024px)
        max-height: 40px
      @media screen and (max-width: 1023px)
        max-height: 140px
      .normalText
        font-weight: 500
        font-size: 16px
        line-height: 130%
        color: #DCE7F2
      .textsContainer
        display: flex
        flex-direction: row
        .mehrText
          color: v-bind('pages.detailReport.firstSteps.checklist.askMoreColor')
          cursor: pointer
          @media screen and (min-width: 1024px)
            margin-left: 6px
          @media screen and (max-width: 1023px)
            width: 100%
            font-weight: 600 !important
      .hiddenContent
        margin-top: 20px
        .redText
          margin-top: 20px
          color: #EB604F
        .showLess
          margin-top: 20px
          font-weight: 600
          font-size: 14px
          line-height: 130%
          color: #626C85
          cursor: pointer
</style>
